export default __webpack_public_path__ + "static/media/Gomez.9180563e.jpg";